import T from './cote.html'
function normalizeCote (cote){
    switch(cote+''){
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
        case '10':
            return cote;
        default:
            return '-';
    }
}

export const CoteG = M.View.extend({
    template: _.template(T),
    tagName: 'span',
    attributes: function(){
        return {
            class: 'label label-cote cote-' + normalizeCote(this.model.get('cote_g'))
        }
    },
    serializeData: function(){
        return {
            cote: normalizeCote(this.model.get('cote_g')),
            type: this.model.get('cote_g_type')
        }
    }
})

export const CoteP = M.View.extend({
    template: _.template(T),
    tagName: 'span',
    attributes: function(){
        return {
            class: 'label label-cote cote-' + normalizeCote(this.model.get('cote'))
        }
    },
    serializeData: function(){
        return {
            cote: normalizeCote(this.model.get('cote')),
            type: this.model.get('cote_type')
        }
    }
})

export const Cote = M.View.extend({
    template: _.template('<span class="cotep"></span><span class="coteg"></span>'),
    regions: {
        cotep: {
            el: '.cotep',
            remplaceElement: true,
        },
        coteg: {
            el: '.coteg',
            remplaceElement: true,
        }
    },
    tagName: 'span',
    onRender: function(){
        this.showChildView('cotep', new CoteP({model: this.model}));
        this.showChildView('coteg', new CoteG({model: this.model}));
    }
})

